module.exports = __webpack_public_path__ + "static/media/Sharp-LCD-Specification-LS044Q7DH01-10-17-19.0f9a9c53.pdf";